<template>
  <page-section :title="$t('Integrations_Overview_Information')">
    <form-section>
      <b>{{ $t('Integrations_Warply_Field_ApiEndpoint') }}</b>
      : {{ apiEndpoint }}
    </form-section>
    <integration-tasks-table
      :integration-id="model.id"
      :task-identifiers="['warply_couponsets_sync']"
    />
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import FormSection from '@/common/components/form/FormSection'
import IntegrationTasksTable from '@/modules/integrations/components/IntegrationTasksTable'
export default {
  name: 'WarplyOverview',
  components: { IntegrationTasksTable, FormSection, PageSection },
  props: {
    model: {
      required: false
    }
  },
  computed: {
    apiEndpoint() {
      if (this.$store.state.app.domains.external_api) {
        return `https://${this.$store.state.app.domains.external_api}/api/external/warply-updates/${this.model.id}/couponset-update`
      }
      return '#'
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/warply/WarplyOverview.vue